import React from 'react';
import Table from '../../components/common/Table';
import { QuestionOptionDTO } from '../../services/apiClient';
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime';
import { renderBooleanBadge } from '../../utils/displayUtils';

interface QuestionOptionTableProps {
  data: QuestionOptionDTO[];
  handleEdit: (row: QuestionOptionDTO) => void;
  handleDelete: (row: QuestionOptionDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const QuestionOptionTable: React.FC<QuestionOptionTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
        {
          label: 'Option',
          key: 'title',
        },
        {
          label: 'Correct',
          key: 'isActive',
          render: (row: QuestionOptionDTO) =>
            renderBooleanBadge(row.isCorrectOption ?? false, 'Yes', 'No'),
        },
        {
          label: 'Added',
          key: 'createdUtc',
          format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
        },
      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default QuestionOptionTable;
